import React, { useEffect } from "react";
import Header from "../components/Layout/Header";
import TermAndCondition from "../components/TermAndCondition/TermAndCondition";

const TermAndConditionPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <Header />
      <TermAndCondition />
    </>
  );
};

export default TermAndConditionPage;
